import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import ManageAccessDropdown from 'Components/document/ManageAccessDropdown';
import AffinitySearchResultItem from 'Components/person/components/AffinitySearchResultItem';
import { selectCollabPopupData } from 'Selector/DocumentHubSelector';
import { actions } from 'Slice/DocumentHubSlice';
import {
  primaryColor,
  primaryFont, primaryHeadingColor, scrollbar, secondaryFont, wLight, wMBold,
  wMedium,
} from 'Utils/utilsStyle';

import { Checkbox, Modal, Radio } from 'antd';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useCollaboratorSelection } from 'Utils/hooks/useCollaboratorSelection';
import { FolderAccessType } from 'Types/DocumentHubTypes';
import NoDataFound from '../components/NoDataFound';
import AffinitySearchResultItemSkeleton from '../skeleton/AffinitySearchResultItemSkeleton';

const StyledModal = styled(Modal)`
 &.ant-modal {
  .ant-modal-content {
    .ant-modal-close {
      display: none;
    }
    .ant-modal-body {
      padding: 27px 30px 0px !important;
      .header-popup-div {
        .header-title {
          color: ${primaryHeadingColor};
          font-family: ${secondaryFont};
          font-size: 24px;
          font-style: normal;
          font-weight: ${wMBold};
          line-height: 27px;
          letter-spacing: -0.45px;
          margin-bottom: 16px;
        }
        .search-wrapper {
          margin: 0px;
          .ant-input-affix-wrapper {
            height: 36px;
            padding: 6.5px 9px;
            .ant-input-prefix {
              .search-global-icon-svg {
                width: 15px;
                height: 15px;
              }
            }
            .ant-input {
              font-size: 14px;
              font-weight: ${wLight};
            }
            input::placeholder {
              font-size: 14px;
              font-weight: ${wLight};
              color: #C1C1C1;
            }
          }
          .cross-icon {
            cursor: pointer;
            top: 9px;
            right: 9px;
          }
        }
        .tabs-div {
          display: flex;
          align-items: center;
          .tab-text {
            &.activeTab {
              color: ${primaryColor};
              border-bottom: 2px solid ${primaryColor};
            }
            color: #667982;
            font-family: ${secondaryFont};
            font-size: 14px;
            font-style: normal;
            font-weight: ${wMedium};
            line-height: 20px;
            letter-spacing: -0.625px;
            width: 50%;
            text-align: center;
            padding: 8px 0px;
            border-bottom: 2px solid #fff;
            cursor: pointer;
          }
        }
      }
      .inner-content-div {
        .header-for-select {
          display: flex;
          align-items: center;
          border-top: 1px solid #CACACA;
          border-bottom: 1px solid #CACACA;
          margin: 0 -30px;
          padding: 10px 30px;
          .ant-checkbox-wrapper {
            width: fit-content;
            margin-bottom: 0;
            margin-right: 12px;
          }
          .checkbox-title {
            color: ${primaryHeadingColor};
            font-family: ${primaryFont};
            font-size: 14px;
            font-style: normal;
            font-weight: ${wMedium};
            line-height: 16px;
            letter-spacing: -0.315px;
          }
        }
        .collaborators-infinite-scroll {
          .no_data_found {
            height: unset;
          }
           .skeletons-for-search-item {
              margin-left: 10px;
            }
          &.noDataWrapper {
            display: flex;
            flex-direction: column;
          }
          margin-top: 12px;
          ${scrollbar};
          .collaborators-div {
            &.manageCollaborators {
              justify-content: space-between;
              .affinity-search-results {
                width: 200px;
              }
            }
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            .affinity-search-results {
              &:hover {
                background-color: #fff;
              }
              padding: 0px;
              .checkbox-search {
                .ant-checkbox-wrapper {
                  margin-bottom: 0;
                }
              }
              .content {
                .name {
                  font-size: 16px;
                  line-height: normal;
                  font-weight: ${wMBold};
                }
                .designation {
                  margin: 0;
                  font-size: 12px;
                }
                .company {
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
      .second-footer-div {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 25px;
        .radio-buttons-div {
          display: flex;
          align-items: center;
          margin: 0 6px;
          .ant-radio-wrapper {
            height: 20px;
          }
          .radio-text {
            color: ${primaryHeadingColor};
            font-family: ${primaryFont};
            font-size: 14px;
            font-style: normal;
            font-weight: ${wMedium};
            line-height: 16px;
            letter-spacing: -0.45px;
            margin-bottom: 0;
          }
        }
      }
    }
    .ant-modal-footer {
      padding: 10px 25px 25px;
      button {
        &:hover {
          outline: none;
        }
        font-family: ${primaryFont};
        line-height: normal;
        border-radius: 25px;
        outline: none;
        height: 36px;
        margin: 0px 4px;
        padding: 8px 17px;
        min-width: 110px;
      }
    }
  }
 }
`;

const updateArr = {
  view: [] as number[],
  edit: [] as number[],
  remove: [] as number[],
};

const AddCollaboratorsPopup = function AddCollaboratorsPopup() {
  const dispatch = useDispatch();
  const {
    visible, currentView, collaborators, people, peopleSearchTerm,
    collaboratorsSearchTerm, folderId,
    peopleCount, collaboratorsCount, collaboratorsEnded, peopleEnded,
    isPeopleSelectAll, isCollaboratorsSelectAll, selectedPeople, selectedCollaborators,
    unSelectedPeople, unSelectedCollaborators,
    peopleSearchList, collaboratorsSearchList, peopleLoading, collaboratorsLoading, updating,
  } = useSelector(selectCollabPopupData);
  const isCollaborator = currentView === 'collaborators';
  const manageAccess = currentView === 'collaborators';
  const searchTerm = isCollaborator ? collaboratorsSearchTerm : peopleSearchTerm;
  const displayPeople = isCollaborator ? collaborators : people;
  const displayPeopleEnded = isCollaborator ? collaboratorsEnded : peopleEnded;
  const isSelectAll = isCollaborator ? isCollaboratorsSelectAll : isPeopleSelectAll;
  const selected = isCollaborator ? selectedCollaborators : selectedPeople;
  const unselected = isCollaborator ? unSelectedCollaborators : unSelectedPeople;
  const searchList = isCollaborator ? collaboratorsSearchList : peopleSearchList;
  const radioEnable = isCollaborator ? collaboratorsCount > 0 && (selectedCollaborators?.length > 0 || (isCollaboratorsSelectAll && unSelectedCollaborators.length !== collaboratorsCount) || collaboratorsSearchList.some((l) => l.isSelectAll || l.ids.length)) : peopleCount > 0 && (selectedPeople?.length > 0 || (isPeopleSelectAll && unSelectedPeople.length !== peopleCount) || peopleSearchList.some((l) => l.isSelectAll || l.ids.length));

  const [currentRadio, setCurrentRadio] = useState<'view' | 'edit' | 'remove' | null>(null);
  const disablePrimaryButton = isCollaborator ? (!radioEnable && !updateArr.edit.length && !updateArr.remove
    .length && !updateArr.view.length) || (radioEnable && !currentRadio) : !radioEnable || !currentRadio;
  const {
    isHeaderCheckboxChecked, handleCheckAll,
    structureSearchList,
  } = useCollaboratorSelection();

  useEffect(() => {
    setCurrentRadio(null);
  }, [currentView]);

  const fetchData = () => {
    if (visible && (!searchTerm || displayPeople.length)) {
      dispatch(actions.getCollabPopupData({
        offset: currentView === 'collaborators' ? collaborators?.length : people?.length,
        limit: 20,
        type: currentView,
        ...searchTerm?.length && { searchTerm },
        folderId,
        isSelectAll,
        selectedIds: selected?.join(',') || '',
        unSelectedIds: unselected?.join(',') || '',
        searchList: structureSearchList(searchList),
      }));
    }
  };

  useEffect(() => {
    if (visible && !displayPeople.length && !displayPeopleEnded) {
      fetchData();
    }
  }, [visible, currentView]);

  const handleSearch = (value: string) => {
    const trimmedValue = value.trim();
    if (trimmedValue?.length && searchTerm !== trimmedValue) {
      dispatch(actions.getCollabPopupData({
        offset: 0,
        limit: 20,
        type: currentView,
        searchTerm: trimmedValue,
        folderId,
        isSelectAll,
        selectedIds: selected?.join(',') || '',
        unSelectedIds: unselected?.join(',') || '',
        searchList: structureSearchList(searchList),
      }));
    } else if (searchTerm.length && !trimmedValue.length) {
      dispatch(actions.getCollabPopupData({
        offset: 0,
        limit: 20,
        type: currentView,
        searchTerm: '',
        folderId,
        isSelectAll,
        selectedIds: selected?.join(',') || '',
        unSelectedIds: unselected?.join(',') || '',
        searchList: structureSearchList(searchList),
      }));
    }
    dispatch(actions.setPeopleSearchTerm(trimmedValue));
  };

  const onOk = () => {
    if (isCollaborator) {
      if (radioEnable) {
        dispatch(actions.updateCollaborators({
          type: 'collaborators',
          isSelection: true,
          searchTerm: '',
          folderId,
          isSelectAll,
          selectedIds: selected?.join(',') || '',
          unSelectedIds: unselected?.join(',') || '',
          searchList: structureSearchList(searchList),
          action: currentRadio as 'edit' | 'view',
        }));
      } else {
        dispatch(actions.updateCollaborators({
          type: 'collaborators',
          isSelection: false,
          folderId,
          editAccessUsers: updateArr.edit.join(','),
          viewAccessUsers: updateArr.view.join(','),
          removeAccessUsers: updateArr.remove.join(','),
        }));
      }
    } else {
      dispatch(actions.updateCollaborators({
        type: 'people',
        isSelection: true,
        searchTerm: '',
        folderId,
        isSelectAll,
        selectedIds: selected?.join(',') || '',
        unSelectedIds: unselected?.join(',') || '',
        searchList: structureSearchList(searchList),
        action: currentRadio as 'edit' | 'view',
      }));
    }
    updateArr.edit = [];
    updateArr.remove = [];
    updateArr.view = [];
  };

  const handleAccessChange = (id: number) => (type: FolderAccessType) => {
    (Object.keys(updateArr) as Array<keyof typeof updateArr>).forEach((key) => {
      if (key !== type) {
        updateArr[key] = updateArr[key].filter((num) => num !== id);
      }
    });

    if (!updateArr[type].includes(id)) {
      updateArr[type].push(id);
    }
    dispatch(actions.updateCollaboratorsAccess({
      id, type,
    }));
  };

  const onCancel = () => {
    dispatch(actions.toggleCollabPopup(false));
    updateArr.edit = [];
    updateArr.remove = [];
    updateArr.view = [];
  }

  return (
    <StyledModal
      open={visible}
      centered
      width={379}
      getContainer=""
      wrapClassName="add-collaborator-popups"
      onCancel={onCancel}
      onOk={onOk}
      closable
      maskClosable={false}
      okText={manageAccess ? 'Update' : 'Grant Access'}
      cancelText="Cancel"
      okButtonProps={{ disabled: disablePrimaryButton || updating }}

    >
      <div className="header-popup-div">
        <h3 className="header-title">{`${manageAccess ? '' : 'Add '}Collaborators`}</h3>
        <AlertsSearch
          placeholderText="Search People"
          onSearching={handleSearch}
          query={searchTerm}
          loading={false}
        />
        <div className="tabs-div">
          <span
            role="button"
            tabIndex={0}
            onClick={() => dispatch(actions.setCollabPopupType('people'))}
            onKeyPress={() => dispatch(actions.setCollabPopupType('people'))}
            className={classNames('tab-text', { activeTab: !manageAccess })}
          >
            Total People (
            {`${peopleCount}`}
            )
          </span>
          <span
            role="button"
            tabIndex={0}
            onClick={() => dispatch(actions.setCollabPopupType('collaborators'))}
            onKeyPress={() => dispatch(actions.setCollabPopupType('collaborators'))}
            className={classNames('tab-text', { activeTab: manageAccess })}
          >
            Collaborators (
            {`${collaboratorsCount}`}
            )
          </span>
        </div>
      </div>
      <div className="inner-content-div">
        <div className="header-for-select">
          <Checkbox checked={isHeaderCheckboxChecked} onChange={handleCheckAll} disabled={!displayPeople.length} />
          <span className={classNames('checkbox-title', { disabled: !displayPeople.length })}>Select All</span>
        </div>
        {currentView === 'collaborators' ? (
          <InfiniteScroll
            hasMore
            dataLength={collaborators.length}
            next={collaborators.length ? fetchData : () => { }}
            loader={false}
            className={classNames('collaborators-infinite-scroll', { noDataWrapper: true })}
            height={227}
          >
            {collaborators?.map((person) => (
              <div className={classNames('collaborators-div', { manageCollaborators: manageAccess })}>
                <AffinitySearchResultItem
                  key={1}
                  person={person}
                  onClickHandler={() => { }}
                  isSelected={false}
                  isChecked={person.isSelected}
                  isDisabled={false}
                  checkboxShow
                  radioBtn={false}
                />
                <ManageAccessDropdown disabled={radioEnable} tickedType={person.removeAccess === 1 ? 'remove' : person.editAccess === 1 ? 'edit' : 'view'} onClick={handleAccessChange(person?.userId || 0)} />
              </div>
            ))}
            {collaboratorsEnded && !collaborators.length
              ? <NoDataFound title="No Person Found" />
              : null}
            {
              collaboratorsLoading && (
                <div className="skeletons-for-search-item">
                  {[1, 2, 3, 4].map(() => <AffinitySearchResultItemSkeleton />)}
                </div>
              )
            }
          </InfiniteScroll>
        ) : null}
        {currentView === 'people' ? (
          <InfiniteScroll
            hasMore
            dataLength={people.length}
            next={people.length ? fetchData : () => { }}
            loader={false}
            className={classNames('collaborators-infinite-scroll', { noDataWrapper: false })}
            height={227}
          >
            {people.map((person) => (
              <div className={classNames('collaborators-div', { manageCollaborators: manageAccess })}>
                <AffinitySearchResultItem
                  key={1}
                  person={person}
                  onClickHandler={() => { }}
                  isSelected={false}
                  isChecked={person.isSelected}
                  isDisabled={false}
                  checkboxShow
                  radioBtn={false}
                />
              </div>
            ))}
            {!people.length && peopleEnded ? <NoDataFound title="No Person Found" /> : null}
            {
              peopleLoading && (
                <div className="skeletons-for-search-item">
                  {[1, 2, 3, 4].map(() => <AffinitySearchResultItemSkeleton />)}
                </div>
              )
            }
          </InfiniteScroll>
        ) : null}

      </div>
      <div className={classNames('second-footer-div', { disabled: !radioEnable })}>
        <div className="radio-buttons-div">
          <Radio onClick={() => { setCurrentRadio('view'); }} checked={currentRadio === 'view'} />
          <p className="radio-text">View</p>
        </div>
        <div className="radio-buttons-div">
          <Radio onClick={() => { setCurrentRadio('edit'); }} checked={currentRadio === 'edit'} />
          <p className="radio-text">Edit</p>
        </div>
        {manageAccess ? (
          <div className="radio-buttons-div">
            <Radio onClick={() => { setCurrentRadio('remove'); }} checked={currentRadio === 'remove'} />
            <p className="radio-text">Remove Access</p>
          </div>
        ) : null}
      </div>
    </StyledModal>
  );
};

export default AddCollaboratorsPopup;
